import { COMMON_PERMISSIONS } from '@/commons/permissoesGrupos';

export default [
    // Home
    {
        path: '/inicio',
        name: 'home',
        component: () => import('@/views/HomeView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
            isRotaOrigem: true,
        },

    },
    // ChangeLogs
    {
        path: '/changelogs',
        name: 'changelogs',
        component: () => import('@/views/changelog/ChangelogView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        },
    },

]